import { useGameStore } from '../store/GameStoreContext.ts';
import { clamp } from '@colonist/utils';
import { useCallback } from 'react';
import { useHotkeys } from 'react-hotkeys-hook';
import { StorageWrapper } from '../utils/storage.ts';
import { AudioManager } from '@colonist/audio';
export const useGameUserSettingsSetVolume = ()=>{
    const setVolume = useGameStore((state)=>state.gameUserSettings.setVolume);
    const isMuted = useGameStore((state)=>state.gameUserSettings.isMuted);
    const setIsMuted = useGameStore((state)=>state.gameUserSettings.setIsMuted);
    const onVolumeChanged = useGameStore((state)=>state.gameClientConfig.onVolumeChanged);
    const setVolumeWithClamp = useCallback((newVolume, showNotification = false)=>{
        const clampedVolume = clamp(newVolume, 0, 1);
        setVolume(clampedVolume);
        AudioManager.setMasterVolume(clampedVolume);
        if (isMuted && clampedVolume > 0) {
            setIsMuted(false);
        }
        if (showNotification) {
            const volumeDisplayLevel = Math.round(clampedVolume * 100);
            onVolumeChanged(volumeDisplayLevel);
        }
    }, [
        setVolume,
        isMuted,
        setIsMuted,
        onVolumeChanged
    ]);
    return setVolumeWithClamp;
};
export const useGameUserSettingsToggleMuteVolume = ()=>{
    const volume = useGameStore((state)=>state.gameUserSettings.volume);
    const isMuted = useGameStore((state)=>state.gameUserSettings.isMuted);
    const setIsMuted = useGameStore((state)=>state.gameUserSettings.setIsMuted);
    const onToggledMuteVolume = useGameStore((state)=>state.gameClientConfig.onToggledMuteVolume);
    const toggleMuteVolume = useCallback((showNotification)=>{
        const newIsMuted = !isMuted;
        setIsMuted(newIsMuted);
        const effectiveVolume = newIsMuted ? 0 : volume;
        AudioManager.setMasterVolume(effectiveVolume);
        if (showNotification) onToggledMuteVolume(newIsMuted);
    }, [
        volume,
        isMuted,
        setIsMuted,
        onToggledMuteVolume
    ]);
    return toggleMuteVolume;
};
export const useGameUserSettingsVolumeHotkeys = ()=>{
    const volume = useGameStore((state)=>state.gameUserSettings.volume);
    const setVolumeWithClamp = useGameUserSettingsSetVolume();
    const toggleMuteVolume = useGameUserSettingsToggleMuteVolume();
    const VOLUME_INCREMENT = 0.1;
    useHotkeys('ArrowUp', ()=>{
        if (!StorageWrapper.getKeyboardShortcuts()) return;
        setVolumeWithClamp(volume + VOLUME_INCREMENT, true);
    });
    useHotkeys('ArrowDown', ()=>{
        if (!StorageWrapper.getKeyboardShortcuts()) return;
        setVolumeWithClamp(volume - VOLUME_INCREMENT, true);
    });
    useHotkeys('m', ()=>{
        if (!StorageWrapper.getKeyboardShortcuts()) return;
        toggleMuteVolume(true);
    });
};
